export default {
  title: "Abmelden",
  processing: "Ihre Abmeldeanfrage wird verarbeitet...",
  success_title: "Erfolgreich abgemeldet",
  success_message: "Sie wurden erfolgreich von unserer Mailingliste abgemeldet.",
  error_title: "Abmeldung fehlgeschlagen",
  error_message:
    "Wir konnten Ihre Abmeldeanfrage nicht verarbeiten. Bitte versuchen Sie es später erneut.",
  go_home: "Zur Startseite gehen",
};
